import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import {
  FinacUsersType,
  LoginResponseType,
} from "../../../redux/auth/authTypes";
import { CircularAvatar, DropDown, ErrorSuccessModal, Loader } from "../../commons";
import { components } from "react-select";
import { ID_PASSWORD_CATEGORY_LIST } from "../../../constant/idPasswordCategoryList";
import { SelctOptionType } from "../../DisbursementModule/DisbursementModuleForm/AddEditDisbursementForm";
import { getTokenGenerateForDownloadAction, resetIdPasswordManagerError, resetIdPasswordManagerStatusCode, resetIdPasswordManagerSuccess, resetSasTokenForDownloadFile, resetUploadedFiles, uploadFilesAction } from "../../../redux/stcoTools";
import { RootState } from "../../../redux/rootReducers";
import { connect } from "react-redux";
import { RedDeleteIcon } from "../../../assets/images";
import { resetSession } from "../../../redux/auth";
import { GetGenerateSasTokenPayloadType, UploadFilePayloadType } from "../../../commonTypes/stcoToolsType";
import { FileUploadData } from "../../../redux/stcoTools/stcoToolsType";

type UserListType = {
  label: string | null | undefined;
  value: number | null | undefined | string;
};

type AppProps = {
  history: any;
  token: string | null;
  finacUsersList: [] | FinacUsersType[];
  finacClientUsersList: any;
  editData?: any;
  loginData: LoginResponseType;
  fetching: boolean;
  totalUserCount?: number | string | any;
  handleSubmitAddClientIdPasswordForm?: (data: any) => void;
  handleSubmitEditClientIdPasswordForm?: (data: any) => void;
  assignedClientsToUserList?: any;
  setoffset: (data: any) => void;
  setText: (data: any) => void;
  setLimit: (data: any) => void;
  limit: number;
  offset: number;
  userFetching: boolean;
  client_code?: number;
  company_name?: string;
  success: number | null;
  statusCode: number | null;
  error: string | null;
  handleGoBack?: () => void;
  dispatchUploadFilesAction:(data:UploadFilePayloadType)=>void;
  fileUploadData:FileUploadData[]|[];
  dispatchResetUploadedFiles:()=>void;
  fileUploadFetching:boolean;
  dispatchGetTokenGenerateForDownloadAction:(data:GetGenerateSasTokenPayloadType)=>void;
  dispatchResetSasTokenForDownloadFile:()=>void;
  sasTokenForDownloadFile:string;
  dispatchResetSession: () => void;
  dispatchResetIdPasswordManagerError: () => void;
  dispatchResetIdPasswordManagerSuccess: () => void;
  dispatchResetIdPasswordManagerStatusCode: () => void;
  
};

const AddEditClientIdPasswordManagerForm = ({
  history,
  token,
  finacUsersList,
  loginData,
  handleSubmitAddClientIdPasswordForm,
  handleSubmitEditClientIdPasswordForm,
  editData,
  fetching,
  setoffset,
  setText,
  setLimit,
  limit,
  offset,
  userFetching,
  assignedClientsToUserList,
  company_name,
  client_code,
  finacClientUsersList,
  handleGoBack,
  dispatchUploadFilesAction,
  fileUploadData,
  dispatchResetUploadedFiles,
  fileUploadFetching,
  dispatchGetTokenGenerateForDownloadAction,
  dispatchResetSasTokenForDownloadFile,
  sasTokenForDownloadFile,
  success,
  error,
  statusCode,
  dispatchResetIdPasswordManagerError,
  dispatchResetIdPasswordManagerSuccess,
  dispatchResetIdPasswordManagerStatusCode,
  dispatchResetSession

}: AppProps) => {
  const defaultTeamMembersString =
    process.env.REACT_APP_DEFAULT_ACCESS_TEAMS_MEMBERS || "[]";
  const defaultTeamMembers: SelctOptionType[] = JSON.parse(
    defaultTeamMembersString
  ) as SelctOptionType[];
  const defaultTeamMembersIds: any[] | [] = defaultTeamMembers?.map(
    (ids) => ids.value
  );
  const [finalUserList, setFinalUserList] = useState<UserListType[] | []>([]);
  const [finalClientUsersList, setFinalClientUsersList] = useState<
    UserListType[] | []
  >([]);
  const [loadCondition, setLoadCondition] = useState(true);
  const editedCategory = ID_PASSWORD_CATEGORY_LIST?.filter((e: any) => {
    if (e.value === editData?.category) {
      return e.label;
    }
  });
  const [selectedAccessTeam, setSelectedAccessTeam] = useState(
    editData ? [] : [defaultTeamMembersIds[0]]
  );
  const [selectCategory, setSelectategory] = useState({
    label: "Select Category",
    value: "",
  });
  const [finalClientList, setFinalClientList] = useState<UserListType[] | []>(
    []
  );
  const [selectClient, setSelectClient] = useState({
    label: `(${client_code}) ${company_name}`,
    value: client_code,
  });

  const [userSelected, setUserSelected] = useState<any>([
    editData
      ? {
          value: null,
          label: "",
        }
      : defaultTeamMembers[0],
  ]);

  const [inputDetails, setInputDetails] = useState({
    title: "",
    url: "",
    loginId: "",
    password: "",
    comments: "",
    targetAudiences: "",
  });
  const [formError, setFormError] = useState({
    titleError: "",
    clientNameError: "",
    clientCodeError: "",
    categoryError: "",
    accessMemberError: "",
  });

  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [uploadFiles, setUploadFiles] = useState<FileUploadData[]|[]>();


  useEffect(()=>{
    dispatchResetIdPasswordManagerSuccess()
    dispatchResetIdPasswordManagerError()
    dispatchResetIdPasswordManagerStatusCode()
    dispatchResetUploadedFiles();
    dispatchResetSasTokenForDownloadFile();
  },[])


  const handleFileClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const Option = (props: any) => {
    const { data } = props;
    return (
      <components.Option {...props}>
        <div
          className="d-flex justify-content-sm-start"
          style={{ gap: "10px" }}
        >
          <CircularAvatar
            name={data?.label}
            image={data?.image && data?.image}
          />
          {data?.label}
        </div>
      </components.Option>
    );
  };

  useEffect(() => {
    if (finacUsersList?.length) {
      const data = finacUsersList?.filter(
        (e: any) => e.user_id !== loginData?.user_id
      );
      let finalUserData = data?.map((user: FinacUsersType) => {
        return {
          value: user?.user_id,
          label: `${user?.first_name} ${user?.last_name}`,
          image: user?.profile_pic?.file_url,
        };
      });
      if (offset > 0) {
        setFinalUserList([...finalUserList, ...finalUserData]);
      } else {
        setFinalUserList([...finalUserData]);
      }
    }
    //eslint-disable-next-line
  }, [finacUsersList]);

  useEffect(() => {
    if (finacClientUsersList?.length) {
      let finalUserData = finacClientUsersList?.map((user: FinacUsersType) => {
        return {
          value: user?.user_id,
          label: `${user?.first_name} ${user?.last_name}`,
          image: user?.profile_pic?.file_url,
        };
      });
      if (offset > 0) {
        setFinalClientUsersList([...finalClientUsersList, ...finalUserData]);
      } else {
        setFinalClientUsersList([...finalUserData]);
      }
    }
    //eslint-disable-next-line
  }, [finacClientUsersList]);

  useEffect(() => {
    if (assignedClientsToUserList?.length) {
      let finalClientData = assignedClientsToUserList?.map((client: any) => {
        return {
          value: client?.client_code,
          label: `(${client?.client_code}) ${client?.company_name}`,
        };
      });
      setFinalClientList([...finalClientData]);
    }
  }, [assignedClientsToUserList]);

  useEffect(() => {
    if (editData) {
      setInputDetails((prev) => ({
        ...prev,
        title: editData?.title,
        url: editData?.url,
        loginId: editData?.login_id,
        password: editData?.password,
        comments: editData?.comments,
        targetAudiences: editData?.targetaudiences,
      }));
      if (editData?.category) {
        setSelectategory({
          value: editedCategory[0]?.value,
          label: editedCategory[0]?.label,
        });
      }

      setSelectClient({
        value: editData?.client_code,
        label: `(${editData?.client_code}) ${editData?.client_name}`,
      });

      if (editData?.access_member_ids) {
        const editSelecteAccessTeam = editData?.access_member_ids
          ?.filter((e: any) => e?.id !== loginData?.user_id)
          ?.filter((e: any) => e?.is_client !== 1);
        let totleUser = editSelecteAccessTeam?.map((e: any) => {
          return {
            value: e?.id,
            label: e?.user_name,
          };
        });
        const accessTeamMembersId = editSelecteAccessTeam?.map(
          (e: any) => e?.id
        );

        setUserSelected(totleUser);
        setSelectedAccessTeam(accessTeamMembersId);
      }

      if (editData?.uploads && editData?.uploads?.length > 0) {
        setUploadFiles([...editData?.uploads]);
      }
    }
    //eslint-disable-next-line
  }, [editData]);
  // // handle onChange event of the dropdown
  const handleChange = (e: any) => {
    let accessTeamIdName: any = e?.map((e: any) => {
      return e?.value;
    });

    let totaleUser = e?.map((e: any) => {
      return {
        value: e?.value,
        label: e?.label,
      };
    });
    setUserSelected(totaleUser);
    setSelectedAccessTeam(accessTeamIdName);
  };

  const handleCategoryChange = (item: any) => {
    setSelectategory({
      label: item?.label,
      value: item?.value,
    });
    setFormError((prev) => ({
      ...prev,
      ...(item?.value && { categoryError: "" }),
    }));
  };
  const handleClientChange = (item: any) => {
    setSelectClient({
      label: item?.label,
      value: item?.value,
    });
  };




  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files && files.length > 0) {
      const filesArray = Array.from(files); 
      const oversizedFile = filesArray.find((file) => file.size > 5 * 1024 * 1024);
  
      dispatchUploadFilesAction({ token, files: filesArray ,containerType:1}); 
    }
  
    if (fileInputRef.current) {
      fileInputRef.current.value = ""; 
    }
  };



  const handleFileDelete = (index: number) => {
    const filteredFiles = uploadFiles?.filter((_:any, i:any) => i !== index);
    setUploadFiles(filteredFiles);    
  }; 
  

  

  useEffect(() => {
    if(fileUploadData?.length){

      setUploadFiles(fileUploadData);
    }
  }, [fileUploadData]);


  const downloadBlobFile = async (fileName: string) => {
    let finalData = {
      fileUrl: fileName,
      token,
      containerType:1

    };
    dispatchGetTokenGenerateForDownloadAction(finalData);
  };

  useEffect(() => {
    if (sasTokenForDownloadFile) {
      const link = document.createElement("a");
      link.href = sasTokenForDownloadFile;
      link.setAttribute("download", "");
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      dispatchResetSasTokenForDownloadFile();
    }
  }, [sasTokenForDownloadFile]);


  const handleInputDetailschange = (e: any) => {
    const Name = e.target.name;
    setInputDetails((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
    setFormError((prev) => ({
      ...prev,
      ...(!!inputDetails?.title?.length &&
        Name === "title" && { titleError: "" }),
      ...(!!selectClient?.value && { clientNameError: "" }),
    }));
  };

  const handleSubmitForm = () => {
    if (
      inputDetails?.title.trim() &&
      selectClient?.value &&
      selectCategory?.value
    ) {
      const finalData = {
        ...inputDetails,
        token,
        clientName: selectClient?.label?.split(")")[1]?.trim(),
        clientCode: selectClient?.value,
        category: selectCategory?.value,
        accessMemberIds: selectedAccessTeam,
        clientShow: "1",
        uploads:uploadFiles
      };
      if (editData) {
        const EditedFinalData = {
          ...finalData,
          recordId: editData?.record_id,
          gst_number: editData?.gst_number,
          trade_name: editData?.trade_name,
          is_gst_number_registered: editData?.is_gst_number_registered,
          is_gst_number_reregistered: editData?.is_gst_number_reregistered,
        };
        handleSubmitEditClientIdPasswordForm?.(EditedFinalData);
      } else {
        handleSubmitAddClientIdPasswordForm?.(finalData);
      }
    } else {
      setFormError((prev) => ({
        ...prev,
        ...(!inputDetails?.title?.trim() && {
          titleError: "Title required",
        }),
        ...(!selectCategory?.value && {
          categoryError: "Select Category",
        }),
      }));
    }
  };

  const onMenuClose = () => {
    setLoadCondition(true);
  };

  const checkBottom = (e: any) => {
    setLoadCondition(false);
    setoffset((prv: any) => prv + limit);
  };


    const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetIdPasswordManagerError();
            }}
          />
        );
      }
    }

    if (success === 1) {
      return (
        <ErrorSuccessModal
          type="success"
          isOpen={success === 1}
          title="Success"
          message={`Id Password Added Successfully!`}
          buttonText="OK"
          onPress={() => {
            dispatchResetIdPasswordManagerSuccess();
            history.goBack();
          }}
          statusCode={statusCode}
        />
      )
    }

    return false;
  };

  return (
    <>
      <div className="row">
        <div className="col-md-4">
          <form>
            <div className="form-group">
              <div>
                <label htmlFor="clientName">Client Name*</label>
                <DropDown
                  options={finalClientList}
                  value={selectClient}
                  handleChange={handleClientChange}
                  disabled
                />
              </div>
              {!!formError?.clientNameError && (
                <small className="text-danger">
                  {formError?.clientNameError}
                </small>
              )}
            </div>
          </form>
        </div>
        <div className="col-md-5">
          <form>
            <div className="form-group">
              <div>
                <label htmlFor="title">Title*</label>
                <input
                  name="title"
                  type="text"
                  className={`form-control ${
                    !!formError.titleError ? "error-border" : null
                  }`}
                  value={inputDetails?.title}
                  onChange={(e) => handleInputDetailschange(e)}
                />
              </div>
              {!!formError?.titleError && (
                <small className="text-danger">{formError?.titleError}</small>
              )}
            </div>
          </form>
        </div>
        {/* <div className='col-md-4'>
          <form>
            <div className='form-group'>
              <label>
                Access to Client Users
              </label>
              <Select
                className="dropdown"
                placeholder="Search User"
                value={finacClientUserSelected[0]?.label ? finacClientUserSelected : []}
                options={finalClientUsersList}
                onChange={handleFinacClientUserChange}
                isMulti
                isClearable
                components={{ Option }}
                isLoading={userFetching}
                onMenuClose={onMenuClose}
                isSearchable={true}
                onMenuScrollToBottom={(e: any) => checkBottom(e)}
                onInputChange={(e: string) => {
                  setLoadCondition(false);
                  setText(e);
                  setoffset(0);
                }}
              />
            </div>
          </form>
        </div> */}
      </div>
      <div className="row mt-3">
        <div className="col-md-4">
          <form>
            <div className="form-group">
              <label>Category*</label>
              <DropDown
                options={ID_PASSWORD_CATEGORY_LIST}
                value={selectCategory}
                handleChange={handleCategoryChange}
              />
              {!!formError?.categoryError && (
                <small className="text-danger">
                  {formError?.categoryError}
                </small>
              )}
            </div>
          </form>
        </div>
        <div className="col-md-5">
          <form>
            <div className="form-group">
              <label>Access to team members</label>
              <Select
                className="dropdown"
                placeholder="Search User"
                value={userSelected[0]?.label ? userSelected : []}
                options={finalUserList}
                onChange={handleChange}
                isMulti
                isClearable
                components={{ Option }}
                isLoading={userFetching}
                onMenuClose={onMenuClose}
                isSearchable={true}
                onMenuScrollToBottom={(e: any) => checkBottom(e)}
                onInputChange={(e: string) => {
                  setLoadCondition(false);
                  setText(e);
                  setoffset(0);
                }}
              />
            </div>
          </form>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-md-6">
          <form>
            <div className="form-group">
              <div>
                <label htmlFor="URL">URL</label>
                <textarea
                  name="url"
                  className="form-control"
                  value={inputDetails?.url}
                  onChange={(e) => handleInputDetailschange(e)}
                />
              </div>
            </div>
          </form>
        </div>
        <div className="col-md-6">
          <form>
            <div className="form-group">
              <div>
                <label htmlFor="LoginId">Login Id</label>
                <textarea
                  name="loginId"
                  className="form-control"
                  value={inputDetails?.loginId}
                  onChange={(e) => handleInputDetailschange(e)}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-md-6">
          <form>
            <div className="form-group">
              <div>
                <label htmlFor="password">Password</label>
                <textarea
                  name="password"
                  className="form-control"
                  value={inputDetails?.password}
                  onChange={(e) => handleInputDetailschange(e)}
                />
              </div>
            </div>
          </form>
        </div>
        <div className="col-md-6">
          <form>
            <div className="form-group">
              <label>Comments</label>
              <textarea
                name="comments"
                className="form-control"
                value={inputDetails?.comments}
                onChange={(e) => handleInputDetailschange(e)}
              />
            </div>
          </form>
        </div>
      </div>

      <div className="row">
  <div className="col-md-4">
    <form>
      <div className="form-group mt-3 d-flex flex-column">
        <label htmlFor="companyLogo">Upload File</label>

        {uploadFiles&&uploadFiles?.length > 0 ? (
          <div>
            {uploadFiles?.map((file: any, index: number) => (
              <div
                key={index}
                className="d-flex flex-row align-items-center ms-2 mt-3"
              >
                <a
                  href="#"
                  target="_blank"
                  style={{ wordBreak: "break-all", color: "#007bff" ,cursor:'pointer'}}
                  onClick={(e) => {
                    e.preventDefault();
                    downloadBlobFile(file?.file_url);
                  }}
                >
                  {file?.file_name}
                </a>
                <img
                  className="ms-2"
                  src={RedDeleteIcon}
                  alt="delete-icon"
                  onClick={() => handleFileDelete(index)}
                  style={{ cursor: "pointer" }}
                />
              </div>
            ))}
          </div>
        ) : (
          <span
            style={{
              textDecoration: "underline",
              color: "#dd4433",
            }}
          >
            <label
              htmlFor="file-upload"
              // className="fileUploadLabel"
              className="btn btn-outline mt-3"
              onClick={handleFileClick}
          
            >
              + Upload File
            </label>
            <input
              type="file"
              style={{ display: "none" }}
              ref={fileInputRef}
              onChange={handleFileChange}
              accept="image/png, image/gif, application/pdf , image/jpeg, .csv, text/csv, application/vnd.ms-excel, 
                        application/csv, text/x-csv, application/x-csv, text/comma-separated-values, text/x-comma-separated-values, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, .ppt , .pptx"

            />
          </span>
        )}
      </div>
    </form>
  </div>
</div>
{fileUploadFetching && <Loader />}


      <hr></hr>
      <div className="row mt-3">
        <div className="col-md-12 text-right">
          <button
            className="btn"
            style={{ border: "1px solid #bfcbe1", marginRight: "15px" }}
            onClick={() => (handleGoBack ? handleGoBack() : history?.goBack())}
          >
            Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={handleSubmitForm}
            disabled={
              !selectClient?.value ||
              !inputDetails?.title ||
              !selectCategory?.value
            }
          >
            {editData ? "Update" : "Save"}
          </button>
        </div>
      </div>
      {handleErrorModal()}

    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  fileUploadData:state.stcoTools.fileUploadData,
  fileUploadFetching:state.stcoTools.fileUploadFetching,
  sasTokenForDownloadFile: state.stcoTools.sasTokenForDownloadFile,
  success: state.stcoTools.success,
  error: state.stcoTools.error,
  statusCode: state.stcoTools.statusCode,

 
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchUploadFilesAction: (data: UploadFilePayloadType) =>
    dispatch(uploadFilesAction(data)),
  dispatchResetUploadedFiles:()=>dispatch(resetUploadedFiles()),
  dispatchGetTokenGenerateForDownloadAction: (data: GetGenerateSasTokenPayloadType) =>
    dispatch(getTokenGenerateForDownloadAction(data)),
  dispatchResetSasTokenForDownloadFile: () =>
    dispatch(resetSasTokenForDownloadFile()),
  dispatchResetIdPasswordManagerSuccess: () => dispatch(resetIdPasswordManagerSuccess()),
  dispatchResetIdPasswordManagerError: () => dispatch(resetIdPasswordManagerError()),
  dispatchResetIdPasswordManagerStatusCode: () => dispatch(resetIdPasswordManagerStatusCode()),

});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddEditClientIdPasswordManagerForm);
